<template>
    <div class='table-box'>
        <div>
            <el-table :data='tableData' border style='width: 100%'
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
                <el-table-column width='60' type='index' label='序号' show-overflow-tooltip
                    align='center'></el-table-column>
                <el-table-column prop='templateName' show-overflow-tooltip label='模版名称'
                    align='center'></el-table-column>
                <el-table-column prop='templateCode' show-overflow-tooltip label='模板code'
                    align='center'></el-table-column>
                <el-table-column prop='createDate' show-overflow-tooltip label='创建时间' align='center'>
                </el-table-column>
                <el-table-column prop='templateContent' show-overflow-tooltip label='模版内容'
                    align='center'></el-table-column>
                <el-table-column label='操作' align='center' width='150'>
                    <template slot-scope='scope'>
                        <!--  -->
                        <el-button type='text' @click='onlyOne(scope.row)'>单发
                        </el-button>
                        <el-button type='text' @click='moreOne(scope.row)'>群发
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style='margin-top: 15px' background @size-change='handleSizeChange'
                @current-change='handleCurrentChange' :current-page='pageConfig.pageNo' :page-sizes='[5, 10, 20, 50]'
                :page-size='pageConfig.pageSize' layout='total, sizes, prev, pager, next, jumper'
                :total='pageConfig.total'>
            </el-pagination>
        </div>

        <!--弹窗-->
        <el-dialog :close-on-click-modal='false' title='短信模版' :visible.sync='dialogFormVisible'
            :modal-append-to-body='false' :before-close='onDialogClose' width='35%'>
            <el-form :model='addForm' ref="ruleForm" label-width='90px' :rules="rules">
                <el-form-item label='姓名:' prop="name">
                    <el-select v-model="addForm.name" filterable remote style="width: 100%" placeholder="请输入关键词"
                        :remote-method="remoteMethod" @change="handleSelect" @click.native="clearForm"
                        :loading="loading">
                        <el-option v-for="item in options" :key="item.id" :label="item.customerName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='手机号:' prop="phone">
                    <el-select v-model="addForm.phone" filterable remote style="width: 100%" placeholder="请输入关键词"
                        :remote-method="remoteMethod1" @change="handleSelect" @click.native="clearForm1"
                        :loading="loading">
                        <el-option v-for="item in options" :key="item.id" :label="item.phone" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='身份证号:' prop="idCard">
                    <el-input v-model='addForm.idCard' type='text' disabled></el-input>
                </el-form-item>
                <el-form-item label='服务时间:' prop="time" v-if="templateName == '工单派发通知' || templateName == '工单预约通知'">
                    <el-date-picker v-model='addForm.time' style="width: 100%" type='datetime'
                        format='yyyy-MM-dd HH:mm:ss' value-format='yyyy-MM-dd HH:mm:ss'
                        placeholder='请输入服务时间'></el-date-picker>
                </el-form-item>
                <el-form-item label='服务内容:' prop="text" v-if="templateName == '工单预约通知'">
                    <el-input v-model='addForm.text' type='textarea'></el-input>
                </el-form-item>
                <el-form-item label='日期:' prop="date" v-if="templateName == '天气预报'">
                    <el-date-picker v-model='addForm.date' style="width: 100%" type='date' format='yyyy-MM-dd'
                        value-format='yyyy-MM-dd' placeholder='请输入日期'></el-date-picker>
                </el-form-item>
                <el-form-item label='周几:' prop="week" v-if="templateName == '天气预报'">
                    <el-select v-model='addForm.week' placeholder='请选择' style="width: 100%">
                        <el-option v-for="(v, i) in weekList" :label='v' :value='v' :key="i"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='天气:' prop="weather" v-if="templateName == '天气预报'">
                    <el-input v-model='addForm.weather' type='text'></el-input>
                </el-form-item>
                <el-form-item label='温度:' prop="temp" v-if="templateName == '天气预报'">
                    <el-input v-model='addForm.temp' type='text'></el-input>
                </el-form-item>
                <el-form-item label='风速:' prop="wind" v-if="templateName == '天气预报'">
                    <el-input v-model='addForm.wind' type='text'></el-input>
                </el-form-item>
            </el-form>
            <div slot='footer' class='dialog-footer'>
                <el-button @click='onDialogClose'>取 消</el-button>
                <el-button type='primary' @click='summerSubmit'>确 定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' title='短信模版' :visible.sync='dialogFormVisible1'
            :modal-append-to-body='false' :before-close='onDialogClose1' width='45%'>
            <div class='btn_group'>
                <el-button type='success' class='button openBtns' @click="downTemplate">下载模板
                </el-button>
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
                    <span>导入</span>
                </label>
            </div>
            <el-table :data='infoData' border style='width: 100%'
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
                <el-table-column width='60' type='index' label='序号' show-overflow-tooltip
                    align='center'></el-table-column>
                <el-table-column prop='name' show-overflow-tooltip label='姓名' align='center'></el-table-column>
                <el-table-column prop='phone' show-overflow-tooltip label='手机号' align='center'></el-table-column>
                <el-table-column align='center' prop='text' show-overflow-tooltip label='服务内容'>
                </el-table-column>
                <el-table-column align='center' prop='time' show-overflow-tooltip label='服务时间'>
                </el-table-column>
                <el-table-column prop='date' show-overflow-tooltip label='日期' align='center'>
                </el-table-column>
                <el-table-column prop='week' show-overflow-tooltip label='周几' align='center'></el-table-column>
                <el-table-column prop='weather' show-overflow-tooltip label='天气' align='center'></el-table-column>
                <el-table-column align='center' prop='temp' show-overflow-tooltip label='温度'>
                </el-table-column>
                <el-table-column align='center' prop='wind' show-overflow-tooltip label='风速'>
                </el-table-column>
            </el-table>
            <!-- <el-pagination
        style='margin-top: 15px'
        background
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page='pageConfig.pageNo'
        :page-sizes='[5, 10, 20, 50]'
        :page-size='pageConfig.pageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total='pageConfig.total'
      >
      </el-pagination> -->
            <div slot='footer' class='dialog-footer'>
                <el-button @click='onDialogClose1'>取 消</el-button>
                <el-button type='primary' @click='summerSubmit1'>确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from '@/utils/request.js'
import { post } from '@/api/requrestHttp'
import headLine from '../components/headline'
import audioLink from '@/api/audio'
import saveAs from 'file-saver'

export default {
    components: {
        headLine
    },
    data() {
        return {
            formData: {
            },
            rules: {
                name: [
                    { required: true, message: "请输入姓名", trigger: "change" },
                ],
                phone: [
                    { required: true, message: "请输入手机号", trigger: "change" },
                ],
                date: [
                    { required: true, message: "请输入日期", trigger: "change" },
                ],
                time: [
                    { required: true, message: "请输入时间", trigger: "change" },
                ],
                text: [
                    { required: true, message: "请输入服务内容", trigger: "blur" },
                ],
                week: [
                    { required: true, message: "请输入周几", trigger: "blur" },
                ],
                weather: [
                    { required: true, message: "请输入天气", trigger: "blur" },
                ],
                temp: [
                    { required: true, message: "请输入温度", trigger: "blur" },
                ],
                wind: [
                    { required: true, message: "请输入风速", trigger: "blur" },
                ],
            },
            tableData: [],
            dialogFormVisible: false,
            dialogFormVisible1: false,
            pageConfig: {
                pageNo: 1,
                pageSize: 10,
                total: 0
            },
            addForm: {},
            weekList: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            loading: false,
            options: [],
            templateName: '',
            templateCode: '',
            infoData: []
        }
    },
    created() {
        this.getTableData()
    },
    watch: {
    },
    methods: {
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList(query, "")
            } else {
                this.options = []
            }
        },
        remoteMethod1(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList("", query)
            } else {
                this.options = []
            }
        },
        clearForm() {
            if (val) {
                this.addForm = {}
                this.changeFirst()
            }
        },
        clearForm1() {
            if (val) {
                this.addForm = {}
                this.changeFirst()
            }
        },
        getchangeList(query, query1) {
            this.$http
                .request({
                    url: "/jjyl/admin/center/customer/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        customerName: query,
                        phone: query1,
                        customerTypeList:['499','501']
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content != null) {
                            this.options = res.content.list
                        } else {
                            this.options = []
                        }
                        this.loading = false
                    }
                })
        },
        async handleSelect(val) {
            this.options.forEach((item) => {
                if (item.id == val) {
                    this.addForm = JSON.parse(JSON.stringify(item))
                }
            })
            this.addForm.name = this.addForm.customerName
            this.addForm.customerId = this.addForm.id
            this.addForm.phone = this.addForm.phone
        },
        onlyOne(row) {
            this.addForm = {}
            this.dialogFormVisible = true
            this.templateName = row.templateName
            this.templateCode = row.templateCode
        },
        // 查看信息
        moreOne(row) {
            this.dialogFormVisible1 = true
            this.templateName = row.templateName
            this.templateCode = row.templateCode
        },
        onDialogClose() {
            this.dialogFormVisible = false
        },
        onDialogClose1() {
            this.dialogFormVisible1 = false
        },
        summerSubmit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (!this.addForm.phone) {
                        this.$message.warning('请填手机号')
                        return false
                    }
                    let sendMsgParamDTO = {}
                    if (this.templateName == '天气预报') {
                        sendMsgParamDTO = {
                            name: this.addForm.name,
                            date: this.addForm.date,
                            week: this.addForm.week,
                            weather: this.addForm.weather,
                            temp: this.addForm.temp,
                            wind: this.addForm.wind
                        }
                    } else if
                        (this.templateName == '工单派发通知') {
                        sendMsgParamDTO = {
                            name: this.addForm.name,
                            time: this.addForm.time
                        }
                    } else if (this.templateName == '工单预约通知') {
                        sendMsgParamDTO = {
                            name: this.addForm.name,
                            time: this.addForm.time,
                            text: this.addForm.text,
                        }
                    } else {
                        sendMsgParamDTO = {
                            name: this.addForm.name
                        }
                    }
                    this.$http
                        .request({
                            url: "/jjyl/admin/msg/sendMsg",
                            method: "POST",
                            data: {
                                templateCode: this.templateCode,
                                phone: this.addForm.phone,
                                customerId: this.addForm.customerId,
                                sendMsgParamDTO: sendMsgParamDTO
                            },
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                if (res.content != null) {
                                    this.$message.success('发送成功')
                                    this.getTableData()
                                }
                            }
                        })
                }
            })
        },
        // 分页
        handleSizeChange(val) {
            this.pageConfig.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getTableData()
        },
        resert(){
         this.formData={}
        },
        getTableData(params = {}) {
            this.$http
                .request({
                    url: '/jjyl/admin/msg/findList',
                    method: 'POST',
                    data: {
                        pageNo: this.pageConfig.pageNo,
                        pageSize: this.pageConfig.pageSize,
                        templateCode:this.formData.templateCode,
                        templateContent:this.formData.templateContent
                    }
                })
                .then((res) => {
                    if (res.code === 200 && res.content) {
                        const arr = res.content.list || []
                        this.tableData = arr
                        this.pageConfig.total = res.content.count || 0
                    } else {
                        this.tableData = []
                        this.pageConfig.total = 0
                    }
                })
        },
        //下载模版
        downTemplate() {
            this.request2({
                url: "/jjyl/admin/msg/downLoadTemplate",
                method: "POST",
                excel: true,
                data: {},
                responseType: "blob",
            })
                .then((res) => {
                    if (res) {
                        const blob = new Blob([res], {
                            type: "application/vnd.ms-excel",
                        });
                        const fileName = "群发模版.xls";
                        const linkNode = document.createElement("a");
                        linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                        linkNode.style.display = "none";
                        linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
                        document.body.appendChild(linkNode);
                        linkNode.click(); //模拟在按钮上的一次鼠标单击
                        URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                        document.body.removeChild(linkNode);
                        this.$message.success("导出表格成功");
                    }
                });
        },
        //导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.type = 1
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/jjyl/admin/msg/importMsgData",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                result.content.forEach((item) => {
                    if (item.date) {
                       let rg=this.timeChange(item.date,1)
                        console.log(rg,'rg')
                       item.date= rg
                    }
                    if(item.time){
                        let rg=this.timeChange(item.time,2)
                        item.time= rg
                    }
                })
                this.infoData = result.content
                this.$message.success(result.message)
            } 
        },
        timeChange(dateStr,val) {
            const date = new Date(dateStr);
            // 获取年月日时分秒
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            if(val==1){
                return  `${year}-${month}-${day}`
            }else{
                 return  `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            }
        },
        onDialogClose1() {
            this.dialogFormVisible1 = false
            this.infoData = []
        },
        summerSubmit1() {
            this.$http
                .request({
                    url: "/jjyl/admin/msg/sendBatchMsg",
                    method: "POST",
                    data: {
                        templateCode: this.templateCode,
                        sendMsgExcelDTOList: this.infoData
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                          this.$message.success('发送成功')
                            this.dialogFormVisible1 = false
                            this.infoData = []
                    }
                })
        },
    }
}
</script>

<style lang='less' scoped>
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;

    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }

    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}

.searchDomw {
    cursor: pointer;
}
</style>
